import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Container } from "react-bootstrap";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faInstagram, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import './Footer.scss'

interface FooterProps {
    lang: String
}

const Footer: React.FC<FooterProps> = (props: FooterProps) => {
    return (<div className="footer">
        <Container className="roze d-flex justify-content-center mx-0 py-3 row" fluid>
            <div className="col-md-3 d-flex justify-content-center my-2">
                <FontAwesomeIcon color="white" icon={faEnvelope} size={'xl'} />
                <a href="mailto:info@vrouwenindetop.nl" className="nav-link ms-2" style={{ height: 'fit-content' }}><p>info@vrouwenindetop.nl</p></a>
            </div>
            <div className="col-md-3 d-flex justify-content-center my-2">
                <FontAwesomeIcon color="white" icon={faInstagram} size={'xl'} />
                <a href="https://www.instagram.com/womenat.thetop/" className="nav-link ms-2" style={{ height: 'fit-content' }}><p>womenat.thetop</p></a>
            </div>
            <div className="col-md-3 d-flex justify-content-center my-2">
                <FontAwesomeIcon color="white" icon={faLinkedin} size={'xl'} />
                <a href="https://www.linkedin.com/company/vrouwen-in-de-top/" className="nav-link ms-2" style={{ height: 'fit-content' }}><p>vrouwenindetop</p></a>
            </div>
        </Container>
    </div>)
}

export default Footer